import {appFetch, AppFetchResponse} from "../utils/appFetch";

export const createCampaignNotification = async (domain: string, campaignId: number, newNotificationData: any): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `campaigns/${campaignId}/template`,
        method: 'POST',
        params: newNotificationData,
        headers: {
            "Content-Type": "application/json",
        },
        domain,
    });
}